import { Checkbox, FormControlLabel, FormGroup, styled } from '@mui/material';
import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import DialogCloseSvgIcon from '../../../assets/svg/dialog/DialogCloseSvgIcon';
import ErrorMessage from './ErrorMessage';
import { OPERATION_FLAGS_BITS } from './operationFlagsBits';

interface OperationFlagSettingProp {
  handleCloseInputItem: (type: string) => void;
  handleOnChange: (value: string) => void;
  value: string;
}

const SpanRequire = styled('span')`
  color: ${({ theme }) => theme.color.highlight};
`;

const Title = styled(Typography)(({ theme }) => ({
  ...theme.externalTypography.body3,
  color: theme.color.secondary.$60,
}));

const OperationFlagSetting: React.FC<OperationFlagSettingProp> = ({
  handleCloseInputItem,
  handleOnChange,
  value,
}) => {
  // Default: 0b0000100111000110
  const [flagsValue, setFlagsValue] = useState<number>(0b0000100111000110);
  const [touched, setTouched] = useState<boolean>(false);

  useEffect(() => {
    handleOnChange(String(flagsValue));
    setTouched(true);
    // Register the default value once on mount so it's submitted even if the
    // user never touches a checkbox; flagsValue/handleOnChange excluded on purpose.
  }, []);

  const handleBitToggle = (bit: number) => {
    const next = flagsValue ^ (1 << bit);
    setFlagsValue(next);
    setTouched(true);
    handleOnChange(String(next));
  };

  return (
    <div>
      <span>
        <Title>
          {value} <SpanRequire>*</SpanRequire>
        </Title>
      </span>
      <div
        className="container-input"
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
        }}
      >
        <FormGroup sx={{ flex: 1 }}>
          {OPERATION_FLAGS_BITS.map(({ bit, label }) => (
            <FormControlLabel
              key={bit}
              control={
                <Checkbox
                  checked={(flagsValue & (1 << bit)) !== 0}
                  onChange={() => handleBitToggle(bit)}
                />
              }
              label={`${label}`}
            />
          ))}
        </FormGroup>

        <DialogCloseSvgIcon
          className="button"
          onClick={() => handleCloseInputItem(value)}
          style={{ cursor: 'pointer' }}
        />
      </div>
      {!touched && <ErrorMessage message="Empty Input" />}
    </div>
  );
};

export default OperationFlagSetting;
